<div
  *ngIf="error"
  class="fixed right-4 z-[100010] max-w-md w-full transition-all duration-300 ease-in-out error-notification-surface"
  [class.opacity-0]="!error"
  [class.opacity-100]="error"
>
  <div
    class="border rounded-lg shadow-lg p-4 flex items-start gap-3"
    [ngClass]="getBackgroundColor()"
  >
    <!-- Icon -->
    <div class="flex-shrink-0 mt-0.5">
      <i [ngClass]="getIconClass()" class="text-lg"></i>
    </div>

    <!-- Message -->
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium break-words">{{ error.message }}</p>
      <p *ngIf="error.statusCode" class="text-xs mt-1 opacity-75">
        Error Code: {{ error.statusCode }}
      </p>
    </div>

    <!-- Close Button -->
    <button
      (click)="dismiss()"
      class="flex-shrink-0 ml-2 text-current opacity-60 hover:opacity-100 transition-opacity"
      aria-label="Dismiss"
    >
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>
